module.exports = __webpack_public_path__ + "img/4_46.98a5c769.png";